import axios from "axios";
import { api_url } from "./../../apiUtils";
import { getDeviceId } from "./DeviceId";
const accessToken = sessionStorage.getItem("accesstoken");

export const getGameTime = async (name, token) => {
  try {
    const response = await axios.get(`${api_url}game/get-game-time/${name}`, {
      headers: { accesstoken: token },
    });
    let data = response?.data;
    console.log("generateAPiReportSingle", data);
    return data;
  } catch (error) {
    console.error("Error fetching singleGeneratedReport data:", error);
    return null;
  }
};

export const getOpenAndCloseGameService = async (name) => {
  try {
    const response = await axios.get(
      `${api_url}game/get-open-close-game`,

      {
        params: { name: name },
        headers: {
          accesstoken: sessionStorage.getItem("accesstoken"),
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    console.log(error.message);
  }
};
export const selectAllService = async (checked, token) => {
  try {
    const response = await axios.post(
      `${api_url}game/select-all-formation`,
      { checked },
      {
        headers: { accesstoken: token },
      }
    );
    let data = response?.data;
    console.log("generateAPiReportSingle", data);
    return data?.status;
  } catch (error) {
    console.error("Error fetching singleGeneratedReport data:", error);
    return null;
  }
};

//gameSessionService.ts

export async function pingGameSession(gameId) {
  try {
    await fetch(`${api_url}game/extra-game/ping-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accesstoken: accessToken,
      },
      body: JSON.stringify({
        gameId,
        deviceId: getDeviceId(),
        sessionToken: sessionStorage.getItem("sessionId"),
      }),
    });
  } catch (error) {
    console.error(`🔴 Ping failed for ${gameId}:`, error);
  }
}
